export default __webpack_public_path__ + "static/optical-adjustment-do-cdb71a45311a17fdabfdc9659103ad944ea531e38324acb378c978df8c831503.png";